export default __webpack_public_path__ + "static/SRI 3430PW - Product Specifications & Technical Data-25875a124f6a45e8e693e9025ddf3db0.pdf";